export enum StorageType {
    NONE = 'none',
    MEMORY = 'memory',
    LOCAL_STORAGE = 'localStorage',
    SESSION_STORAGE = 'sessionStorage',
    COOKIE = 'cookie',
    SESSION_COOKIE = 'sessionCookie'
}